<template>
  <CSectionCard class="c-media-section">
    <CSectionButton @click="open">
      <CSectionItem>
        <CMediaHeader :mediaFiles="files"/>
        <CDirectionIcon/>
      </CSectionItem>
    </CSectionButton>

    <CSectionItem v-if="visibleMedia.length > 0">
      <CFlex :wrap="showAll">
        <CMediaFileCard2 v-for="mediaFile in visibleMedia" :file="mediaFile" :files :context/>
      </CFlex>
    </CSectionItem>

    <CSectionItem v-if="$slots.footer" class="c-media-section-footer">
      <div>
        <slot name="footer"/>
      </div>
    </CSectionItem>
    <CSectionPrimaryButton v-else :title="$t('media.add')" @click="add"/>
  </CSectionCard>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import DossierModals from '@/dossier/services/DossierModals';
  import MediaContext2 from '@/general/models/MediaContext2';
  import Modal from '@/general/utils/Modal';
  import CDirectionIcon from '@/shared/components/CDirectionIcon.vue';
  import CFlex from '@/shared/components/CFlex.vue';
  import CSectionButton from '@/shared/components/section/CSectionButton.vue';
  import CSectionCard from '@/shared/components/section/CSectionCard.vue';
  import CSectionItem from '@/shared/components/section/CSectionItem.vue';
  import CSectionPrimaryButton from '@/shared/components/section/CSectionPrimaryButton.vue';
  import CMediaFileCard2 from './CMediaFileCard2.vue';
  import CMediaHeader from './CMediaHeader.vue';
  import MediaTargetData from '@/general/models/MediaTargetData';

  const MediaModal2 = () => import('../modals/MediaModal.vue');

  const props = defineProps<{
    context: MediaContext2;
    targetData: MediaTargetData;
    showAll?: boolean;
  }>();

  const MAX_ITEMS = 10;

  const files = computed(() => props.context.getFilteredList(props.targetData));
  const visibleMedia = computed(() => {
    return props.showAll ? files.value : files.value.slice(0, MAX_ITEMS);
  });

  function open(): Promise<void> {
    return Modal.open(MediaModal2, { context: props.context, targetData: props.targetData });
  }

  function add() {
    DossierModals.addMedia2(props.context, props.targetData);
  }
</script>

<style lang="scss">
  .c-media-section {
    &-footer {
      padding: 0;

      .c-button {
        border-radius: 0;
      }
    }
  }
</style>
